// Upryzze\frontend\packages\business-console\src\services\businessService.js

// frontend/packages/business-console/src/services/businessService.js

import { api } from '@upryzze/services';

const isProduction = process.env.NODE_ENV === 'production';

const devWarn = (...args) => {
  if (isProduction) return;
  // eslint-disable-next-line no-console
  console.warn(...args);
};

const ensureString = (value, label) => {
  const v = String(value || '').trim();
  if (!v) throw new Error(`${label} is required.`);
  return v;
};

/**
 * Fetch a business by its slug.
 * Backend: GET /businesses/slug/:slug
 */
export const getBusinessBySlug = (slug) => {
  const safeSlug = ensureString(slug, 'Business slug');
  return api.get(`/businesses/slug/${encodeURIComponent(safeSlug)}`);
};

/**
 * Update the tenant-editable subset of business.settings.
 * Backend: PATCH /businesses/settings (businessadmin-only; active business
 * resolved from the x-business-id header server-side).
 * @param {object} payload e.g. { invoiceRemindersEnabled: false }
 * @returns axios response; response.data.settings is the updated settings.
 */
export const updateBusinessSettings = (payload) =>
  api.patch(`/businesses/settings`, payload);

/**
 * Update the tenant's document branding (logo + brand color) used by the
 * quote / invoice / report renderers.
 * Backend: PATCH /businesses/branding (businessadmin + manager; active
 * business resolved server-side; logo asset ownership-checked).
 * @param {object} payload { logoAssetId?: string|null, primaryColor?: string|null }
 * @returns axios response; response.data.branding has { logoAssetId, primaryColor, logoUrl }.
 */
export const updateBusinessBranding = (payload) =>
  api.patch(`/businesses/branding`, payload);

/**
 * Resolve a business slug from a business ID.
 * Backend: GET /businesses/:id
 */
export const getSlugByBusinessId = async (businessId) => {
  const id = ensureString(businessId, 'Business ID');
  // backend supports GET /api/businesses/:id which returns slug
  const resp = await api.get(`/businesses/${id}`);
  const slug = resp?.data?.slug;
  if (!slug)
    devWarn(
      'businessService.getSlugByBusinessId: missing slug in response',
      resp?.data
    );
  return resp;
};
